import * as React from "react";
import {CardWrapper} from "./Card";

export const LoadingCard: React.FC<any> = () => {
  return (
    <CardWrapper className={"textCenter"} size={"fullCard"}>
      Loading...
    </CardWrapper>
  );
}